module.exports = __webpack_public_path__ + "static/media/erin150_1607367975590.a6153d1b.jpg";